import { authService } from '@/services/auth.js';
import { backboneService } from '@/services/backbone.js';
import { toastService } from '@/services/toast.js';
import { entitlementsService } from '@/services/entitlements-service.js';
import { HatElement } from '@/components/hat-element.js';

class HatLayoutAdmin extends HatElement {
  private _unsubscribe: (() => void) | null = null;
  private _unsubscribeToast: (() => void) | null = null;
  private _docClickHandler: (() => void) | null = null;

  constructor() {
    super();

    this.root.innerHTML = `
      <style>
        :host {
          display: block;
          min-height: 100vh;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          position: relative;
        }

        :host::before {
          content: "";
          position: fixed;
          inset: 0;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          z-index: -1;
        }

        .header {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 56px;
          color: white;
          padding: 0 24px;
          z-index: 2000;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          background: rgba(0,0,0,0.25);
          backdrop-filter: blur(4px);
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .title {
          font-size: 1.2rem;
          font-weight: 700;
          text-shadow: 0 2px 4px rgba(0,0,0,0.5);
        }

        .badge {
          background: rgba(255,255,255,0.2);
          border-radius: 4px;
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.08em;
          padding: 2px 7px;
          text-transform: uppercase;
        }

        .right {
          display: flex;
          align-items: center;
          gap: 12px;
          position: relative;
        }

        .welcome {
          font-size: 0.9rem;
          opacity: 0.9;
          text-shadow: 0 1px 3px rgba(0,0,0,0.5);
        }

        .menu-btn {
          background: none;
          border: none;
          color: white;
          font-size: 22px;
          cursor: pointer;
          text-shadow: 0 1px 3px rgba(0,0,0,0.5);
          line-height: 1;
          padding: 4px;
        }

        .dropdown {
          position: absolute;
          right: 0;
          top: 36px;
          background: white;
          color: black;
          border-radius: 8px;
          box-shadow: 0 4px 14px rgba(0,0,0,0.2);
          display: none;
          flex-direction: column;
          min-width: 160px;
          overflow: hidden;
        }

        .dropdown button {
          padding: 10px 14px;
          border: none;
          background: none;
          text-align: left;
          cursor: pointer;
          font-size: 0.9rem;
          width: 100%;
        }

        .dropdown button:hover { background: #f2f2f2; }

        .menu.open .dropdown { display: flex; }

        .body {
          display: flex;
          padding-top: 56px;
          min-height: 100vh;
        }

        .drawer-backdrop {
          display: none;
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.45);
          z-index: 999;
          cursor: pointer;
        }

        .sidebar {
          position: fixed;
          top: 56px;
          left: 0;
          width: 220px;
          height: calc(100vh - 56px);
          background: rgba(0,0,0,0.2);
          display: flex;
          flex-direction: column;
          padding: 16px 0 0;
          overflow-y: auto;
          box-sizing: border-box;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
          z-index: 1000;
        }

        .sidebar-section {
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.5);
          padding: 0 20px 8px;
          margin-top: 8px;
        }

        .nav-link {
          display: block;
          padding: 10px 20px;
          color: white;
          cursor: pointer;
          border: none;
          background: none;
          text-align: left;
          font-size: 0.95rem;
          width: 100%;
          transition: background 0.15s;
          text-shadow: 0 1px 3px rgba(0,0,0,0.3);
        }

        .nav-link:hover { background: rgba(255,255,255,0.1); }
        .nav-link.active { background: rgba(255,255,255,0.2); font-weight: 600; }

        .sidebar-footer {
          display: none;
          margin-top: auto;
          padding: 12px 0;
          border-top: 1px solid rgba(255,255,255,0.15);
        }

        .sidebar-footer .nav-link {
          font-size: 0.9rem;
          opacity: 0.85;
        }

        main {
          margin-left: 220px;
          flex: 1;
          padding: 32px;
        }

        .toast-container {
          position: fixed;
          bottom: 24px;
          right: 24px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          z-index: 9999;
        }

        .toast {
          padding: 12px 18px;
          border-radius: 8px;
          color: white;
          font-size: 0.9rem;
          box-shadow: 0 4px 14px rgba(0,0,0,0.25);
          animation: toast-in 0.2s ease;
          max-width: 320px;
        }

        .toast.error   { background: #c0392b; }
        .toast.success { background: #27ae60; }
        .toast.info    { background: #2980b9; }

        @keyframes toast-in {
          from { transform: translateX(110%); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }

        @media (max-width: 768px) {
          .sidebar {
            transform: translateX(-100%);
            background: rgba(30, 20, 60, 0.97);
          }

          :host(.nav-open) .sidebar {
            transform: translateX(0);
            box-shadow: 4px 0 24px rgba(0,0,0,0.5);
          }

          :host(.nav-open) .drawer-backdrop {
            display: block;
          }

          .dropdown { display: none !important; }

          .sidebar-footer { display: block; }

          .welcome { display: none; }

          main {
            margin-left: 0;
            padding: 20px 16px;
          }
        }
      </style>

      <header class="header">
        <div class="header-left">
          <span class="title">Home Asset Tracker</span>
          <span class="badge">Admin</span>
        </div>
        <div class="right">
          <div class="welcome"></div>
          <div class="menu">
            <button class="menu-btn">☰</button>
            <div class="dropdown">
              <button class="back-btn">← Back to App</button>
              <button class="logout-btn">Logout</button>
            </div>
          </div>
        </div>
      </header>

      <div class="body">
        <div class="drawer-backdrop"></div>

        <nav class="sidebar">
          <div class="sidebar-section" hat-entitlement="feature.admin.invitations feature.admin.qr-scan">Access Control</div>
          <button class="nav-link" data-path="/admin/users" hat-entitlement="feature.admin.invitations">Users</button>
          <button class="nav-link" data-path="/admin/invitations" hat-entitlement="feature.admin.invitations">Invitations</button>
          <button class="nav-link" data-path="/admin/qrcodes/new" hat-entitlement="feature.admin.qr-scan">New QR Code</button>
          <div class="sidebar-section" hat-entitlement="feature.admin.service-meta">System</div>
          <button class="nav-link" data-path="/admin/services" hat-entitlement="feature.admin.service-meta">Services</button>
          <button class="nav-link" data-path="/admin/testing" hat-entitlement="feature.admin.service-meta">Testing</button>
          <button class="nav-link" data-path="/admin/maintenance-templates" hat-entitlement="feature.admin.service-meta">Maint. Templates</button>
          <button class="nav-link" data-path="/admin/asset-type-properties" hat-entitlement="feature.admin.service-meta">Asset Properties</button>

          <div class="sidebar-footer">
            <button class="nav-link back-btn-mobile">← Back to App</button>
            <button class="nav-link logout-btn-mobile">Logout</button>
          </div>
        </nav>

        <main>
          <slot></slot>
        </main>
      </div>

      <div class="toast-container"></div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this._updateUI();
    this._highlightNav();

    void entitlementsService.load();
    this._unsubscribe = authService.subscribe(() => {
      this._updateUI();
      if (authService.isAuthenticated()) void entitlementsService.load();
    });
    this._unsubscribeToast = toastService.subscribe(({ message, type }: { message: string; type: string }) => {
      this._showToast(message, type);
    });

    this.root.querySelectorAll<HTMLElement>('.nav-link[data-path]').forEach(btn => {
      btn.addEventListener('click', () => {
        this._closeSidebar();
        backboneService.navigateTo(btn.dataset.path ?? null);
      });
    });

    const menu = this.root.querySelector('.menu')!;

    this.root.querySelector('.menu-btn')!.addEventListener('click', (e) => {
      e.stopPropagation();
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.classList.toggle('nav-open');
      } else {
        menu.classList.toggle('open');
      }
    });

    this.root.querySelector('.drawer-backdrop')!.addEventListener('click', () => this._closeSidebar());

    this._docClickHandler = () => menu.classList.remove('open');
    document.addEventListener('click', this._docClickHandler);

    this.root.querySelector('.back-btn')!.addEventListener('click', () => {
      menu.classList.remove('open');
      backboneService.navigateTo('/app');
    });

    this.root.querySelector('.logout-btn')!.addEventListener('click', () => {
      menu.classList.remove('open');
      backboneService.navigateTo('/app/logout');
    });

    this.root.querySelector('.back-btn-mobile')!.addEventListener('click', () => {
      this._closeSidebar();
      backboneService.navigateTo('/app');
    });

    this.root.querySelector('.logout-btn-mobile')!.addEventListener('click', () => {
      this._closeSidebar();
      backboneService.navigateTo('/app/logout');
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this._unsubscribe) this._unsubscribe();
    if (this._unsubscribeToast) this._unsubscribeToast();
    if (this._docClickHandler) document.removeEventListener('click', this._docClickHandler);
  }

  _closeSidebar() {
    this.classList.remove('nav-open');
  }

  _highlightNav() {
    const path = window.location.pathname;
    this.root.querySelectorAll<HTMLElement>('.nav-link[data-path]').forEach(btn => {
      btn.classList.toggle('active', path.startsWith(btn.dataset.path!));
    });
  }

  _updateUI() {
    const welcome = this.root.querySelector('.welcome')!;
    const name = authService.getUserName();
    welcome.textContent = name ? `Welcome: ${name}` : 'Welcome';
    entitlementsService.applyTo(this.root);
  }

  _showToast(message: string, type = 'error') {
    const container = this.root.querySelector('.toast-container')!;
    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.textContent = message;
    container.appendChild(toast);
    setTimeout(() => toast.remove(), 4000);
  }
}

customElements.define('hat-layout-admin', HatLayoutAdmin);